
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 352 322"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"M87.973 282.353l-60.732-105.33a31.6 31.6 0 010-31.538L87.973 40.233c5.646-9.784 16.08-15.795 27.321-15.795H236.68c11.266 0 21.727 6.011 27.321 15.795l60.758 105.304a31.6 31.6 0 010 31.537l-60.732 105.33c-5.646 9.784-16.08 15.795-27.321 15.795H115.372a31.846 31.846 0 01-27.4-15.846z","fill":"#FFF"}}),_c('path',{attrs:{"d":"M93.151 275.197l-57.115-99.06c-5.308-9.185-5.308-20.504 0-29.663l57.115-99.086a29.742 29.742 0 0125.734-14.857h114.23c10.59 0 20.426 5.646 25.734 14.857l57.167 99.034c5.308 9.185 5.308 20.504 0 29.663l-57.141 99.138a29.742 29.742 0 01-25.734 14.858H118.937a29.787 29.787 0 01-25.786-14.884z","fill":"#7C4DFF"}}),_c('path',{attrs:{"d":"M118.469 142.233h117.534a2.649 2.649 0 002.654-2.654v-22.04c0-14.65-11.891-26.54-26.54-26.54h-70.568c-20.53-.026-37.157 16.6-37.157 37.13-.026 7.833 6.27 14.104 14.077 14.104zm11.527 97.368h70.229c21.207 0 38.432-17.225 38.432-38.432 0-7.078-5.724-12.828-12.828-12.828H106.942a2.537 2.537 0 00-2.55 2.55v23.054c-.026 14.181 11.475 25.656 25.604 25.656z","fill":"#F7F7F7"}}),_c('path',{attrs:{"d":"M109.596 139.319l87.663 87.662c5.802 5.803 15.196 5.803 20.998 0l15.196-15.196c5.803-5.802 5.803-15.196 0-20.998l-87.637-87.663c-5.802-5.802-15.196-5.802-20.998 0l-15.196 15.196c-5.855 5.803-5.855 15.222-.026 20.999z","fill":"#F7F7F7"}}),_c('path',{attrs:{"fill":"#444","opacity":".3","d":"M198.69 228.464l-51.495-40.123h11.397zm-54.33-126.797l40.565 40.566h13.765z"}})])])
          )
        }
      }
    